/*
 * @Author: betwaym 848032671@qq.com
 * @Date: 2024-01-26 11:17:39
 * @LastEditors: betwaym 848032671@qq.com
 * @LastEditTime: 2024-01-29 17:20:53
 * @FilePath: \mrc-ess-base-frontend\src\views\login\mixins\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import auth from './auth'
import login from './login'
import ls from '@/utils/Ls';

export default {
    mixins: [auth, login],
    data() {
        return {
            overlay: false,
            remember: true,
            mode: "auth",//登录模式: login, auth
            login_form: true,
        }
    },
    created() {
        // if (process.env.NODE_ENV === "debug") this.mode = "auth";
        if (this.mode === 'login') {
            ls.clear();
            sessionStorage.clear();
        }
    },
    mounted() {
        //监听登录页面enter
        this.handlerEnter(true);
    },
    computed: {
        lang_name() {
            return this.$store.getters.lang_name;
        },
        langList() {
            return this.$store.state.currentCompanyLanguage;
        },
        login_language() {
            return this.$store.getters.lang;
        },
        bgstyle() {
            let size = 0;
            switch (this.$vuetify.breakpoint.name) {
                case "xs":
                    size = 0;
                    break;
                case "sm":
                    size = 600;
                    break;
                case "md":
                    size = 900;

                    break;
                case "lg":
                    size = 1000;

                case "xl":
                    size = 1200;

                    break;
                default:
                    break;
            }
            return size;
        },
    },
    methods: {
        // 给登录页加enter事件和解绑enter事件
        handlerEnter(flag) {
            if (flag) {
                document.onkeydown = (e) => {
                    var theEvent = e || window.event;
                    var code = theEvent.keyCode || theEvent.which || theEvent.charCode;
                    if (code == 13) {
                        if (this.mode === 'login') {
                            this.login();
                        }
                        if (this.mode === 'auth') {
                            this.toAuth();
                        }
                        return false;
                    }
                    return true;
                };
            } else {
                document.onkeydown = null;
            }
        },
        // 语言切换
        lang_change(item) {
            this.$store.commit("set_lang", item);
        },

    },
    destroyed() {
        this.handlerEnter();
    },
}